var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBackofshirt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#6A7282",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m3.017 2.883 3.65-1.216S8.333 2.5 10 2.5s3.333-.833 3.333-.833l3.65 1.216A1.67 1.67 0 0 1 18.1 4.742l-.483 2.891a.83.83 0 0 1-.825.7H15v8.333a1.666 1.666 0 0 1-1.667 1.667H6.667c-.917 0-1.667-.75-1.667-1.666V8.333H3.208a.83.83 0 0 1-.825-.7L1.9 4.742a1.67 1.67 0 0 1 1.117-1.859"
})));
export default SvgBackofshirt;